const hoverList = (): void => {
  const selectors = {
    hoverList: '[data-hover-list]',
    hoverListGrid: '[data-hover-list-grid]',
    hoverListGridCurrent: 'data-hover-list-current',
    hoverListItem: '[data-list-item]',
    hoverListItemID: 'data-list-item',
  };

  const hoverListSections = document.querySelectorAll(selectors.hoverList);

  hoverListSections.forEach((section) => {
    const hoverListGrid = section.querySelector(selectors.hoverListGrid);
    const listItems = hoverListGrid.querySelectorAll(selectors.hoverListItem);
    listItems.forEach((item) => {
      item.addEventListener('mouseover', () => {
        const itemID = item.getAttribute(selectors.hoverListItemID);
        hoverListGrid.setAttribute(selectors.hoverListGridCurrent, itemID);
      });
    });
  });
};

export default hoverList;
